import { Box } from '@material-ui/core';
import { ErrorBox } from '@linearb/linui-common/base';

export const migrationStaleMessage =
  'JIRA data is temporarily not up-to-date due to a system migration. For more information, please contact your system administrator.';

export const MigrationStaleBanner = () => (
  <Box margin={1} marginTop={2}>
    <ErrorBox>{migrationStaleMessage}</ErrorBox>
  </Box>
);
